import React from 'react'
import EditTenantParam from "../actions/EditTenantParam"

const TenantTableItem = (props) => {
    const {item} = props

    return (
        <tr className="RowItem SettingItem">
            <td className="leadName">{item.tenantName}</td>
            <td className="leadName">{item.parName}</td>
            <td className="fieldTitle">{item.parValue}</td>
            <td className="leadName">{item.parTitle}</td>
            <td className={`StatusCol ${item.status === '1' ? 'Completed' : 'Finish'}`}>
                <span>
                    {item.status === '1' ? 'Active' : 'Disable'}
                </span>
            </td>
            <td className="Actions text-center">
                <EditTenantParam currentItem={item}/>
            </td>
        </tr>
    )
}

export default TenantTableItem
